export default __webpack_public_path__ + "static/media/bullet-icon-blue.dd2dc879.svg";